'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseButtons = require('@bibliocommons/base-buttons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PrintLoadNextButton(_ref) {
  var numToLoad = _ref.numToLoad,
      handleClick = _ref.handleClick,
      currentPage = _ref.currentPage,
      totalPages = _ref.totalPages,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === undefined ? false : _ref$isLoading;

  if (currentPage >= totalPages) {
    return null;
  }

  return _react2.default.createElement(
    _baseButtons.PrimaryButton,
    { className: 'btn-sm', handleClick: handleClick, isLoading: isLoading },
    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'load_next', values: { num_items: numToLoad } })
  );
}

PrintLoadNextButton.propTypes = {
  numToLoad: _react.PropTypes.number.isRequired,
  handleClick: _react.PropTypes.func.isRequired,
  isLoading: _react.PropTypes.bool,
  totalPages: _react.PropTypes.number.isRequired,
  currentPage: _react.PropTypes.number.isRequired
};

exports.default = PrintLoadNextButton;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/print/lib/components/print-load-next-button/components/PrintLoadNextButton.component.js
// module id = 1448
// module chunks = 1